import type {
  IOnboardingGetProfileParams,
  IOnboardingGetProfileRequest,
  IOnboardingGetProfileResponse,
} from '@/app-package';

import axios from 'axios';

const getProfile = async (params: IOnboardingGetProfileParams) => {
  const url = `/onboarding/profile/${params.hash}`;

  const config: IOnboardingGetProfileRequest = { url, method: 'get' };

  const { data } = await axios.request<IOnboardingGetProfileResponse>(config);

  return data;
};

export default getProfile;
